<template>
    <v-data-table
    :headers="headers"
    :items="values"
    :footer-props="{
        showFirstLastPage: true,
        'items-per-page-options': [10, 20, 50]
    }"
    >
    </v-data-table>
</template>

<script>
    export default {
        props: {
            values: Array | Object
        },
        data () {
            return {
                headers: [
                    {
                        text: this.$t('backoffice.modules-management.budget.fluids-component.datatable-fluids-headers.description'),
                        align: 'start',
                        value: 'description',
                        class: 'header-table-color'
                    },
                    { text: this.$t('backoffice.modules-management.budget.fluids-component.datatable-fluids-headers.viscosity'), value: 'viscosity',class: 'header-table-color' },
                    { text: this.$t('backoffice.modules-management.budget.fluids-component.datatable-fluids-headers.fluidStandard'), value: 'fluidStandard',class: 'header-table-color' },
                    { text: this.$t('backoffice.modules-management.budget.fluids-component.datatable-fluids-headers.price'), value: 'price',class: 'header-table-color' },
                ],
            }
        },
    }
</script>

<style lang="scss" scoped>

    table{
        thead{
            tr{
                th{
                    border: 0;
                    
                    &.header-table-color{
                        background-color: #F2F2F2 !important;
                        color:#9E9D9D !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody{
            tr{
                td{
                    font-size: 12px;
                    border: 0;
                }
            }
        }

    }
</style>
